import { useAuthenticatedUserContext } from '@/contexts/user-context';

export const useIsOverridingIneligibleItem = (eligibleForCredit: boolean) => {
  const { creditRequestSettings } = useAuthenticatedUserContext();
  return (
    !eligibleForCredit &&
    creditRequestSettings?.request_ineligible_items_enabled
  );
};
